import { Component, EventEmitter, Input, Output } from '@angular/core'

@Component({
  selector: 'custom-checkbox',
  template: `
    <input type="checkbox" [id]="id" [(ngModel)]="checked" (ngModelChange)="handleCheckedChange()" [ngModelOptions]="{standalone: true}" [disabled]="disabled">
    <label [for]="id"><label>
  `,
  styleUrls: ['./checkbox.css']
})
export class CustomCheckboxComponent {
  @Input() checked: boolean
  @Input() disabled: boolean = false
  @Output() checkedChange = new EventEmitter<boolean>();

  id: number = Math.floor(Math.random()*1000)

  handleCheckedChange() {
    this.checkedChange.emit(this.checked)
  }

  click() {
    if (this.disabled) return

    this.checked = !this.checked
    this.checkedChange.emit(this.checked)
  }
}
